<script context="module">
  // @ts-check
  /**
   * valid grid columns for mobile, tablet and desktop
   * @typedef {Object} GRID_COLUMNS
   * @property {1 | 2 | 3 | 4} mobile - accepted mobile grid columns
   * @property {1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12} tablet - accepted tablet grid columns
   * @property {1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12} desktop - accepted desktop grid columns
   */
</script>

<script>
  // @ts-check
  /** Primarily used for testing
   * @type {string}
   * */
  export let id = undefined;

  /** @type {HTMLElement | undefined} */
  export let ref = undefined;

  /** @type { string } */
  export let gridElement = "div";

  /** @type { string } */
  export let gridClass = "";

  /** 
  Subgrid columns for mobile, tablet and desktop
  @type {GRID_COLUMNS} */
  export let subGridColumns = null;

  $: gridSpanMobile = subGridColumns?.mobile || 4;
  $: gridSpanTablet = subGridColumns?.tablet || 12;
  $: gridSpanDesktop = subGridColumns?.desktop || 12;

  const mobileClasses = "w-full grid grid-flow-row justify-stretch gap-x-grid-gutter";
  const mediumClasses = "";
</script>

<svelte:element
  this={gridElement}
  {id}
  bind:this={ref}
  style="--grid-span-mobile: {gridSpanMobile}; --grid-span-tablet: {gridSpanTablet}; --grid-span-desktop: {gridSpanDesktop}"
  class="grid-columns {mobileClasses} {mediumClasses} {gridClass}"
>
  <slot />
</svelte:element>

<style>
  .grid-columns {
    grid-template-columns: repeat(var(--grid-span-mobile), minmax(0, 1fr));
  }

  @media (min-width: 680px) {
    .grid-columns {
      grid-template-columns: repeat(var(--grid-span-tablet), minmax(0, 1fr));
    }
  }

  @media (min-width: 1200px) {
    .grid-columns {
      grid-template-columns: repeat(var(--grid-span-desktop), minmax(0, 1fr));
    }
  }
</style>
